<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="getDentesSupranumerarios()"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(procedimentos)="{item}">
                <div
                    v-for="(procedimento, index) in item.procedimentos"
                    :key="index"
                >
                    {{`${formatProcedimento(procedimento.procedimento.codigo)} - ${procedimento.procedimento.nome}`}}
                </div>
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'local', label: 'Local', sortable: true},
            {key: 'procedimentos', label: 'Procedimentos', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o dente supranumerário?', async () => {
                this.getDentesSupranumerarios().splice(index, 1)
            })
        },
        getDentesSupranumerarios() {
            return this.data.model.saudeBucal.odontograma.dentesSupranumerarios
        },
    },
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
    },
}
</script>